import { render } from "./mvt-estprice.vue?vue&type=template&id=8dbf8894"
import script from "./mvt-estprice.js?vue&type=script&lang=js"
export * from "./mvt-estprice.js?vue&type=script&lang=js"

import "./mvt-estprice.vue?vue&type=style&index=0&id=8dbf8894&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__